import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
import {
  DEV_ENV,
  PROD_ENV,
  NAV_ITEMS,
} from '../common/constants';
import { getNavData } from './universalDataFetchers';
import logger from '../common/logger';

export const fetchNavData = createAsyncThunk(
  'envData',
  ({
    env, isPreview, isSSR,
  }) => getNavData({
    env, isPreview, isSSR,
  }),
);

export const envSlice = createSlice({
  name: 'envData',
  initialState: {
    ENVIRONMENT: DEV_ENV,
    LMS_HEADERS: { },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNavData.pending, (state) => ({
      ...state,
    }));
    builder.addCase(fetchNavData.fulfilled, (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState[NAV_ITEMS] = action?.payload;
      });
      return newState;
    });
    builder.addCase(fetchNavData.rejected, (state, action) => {
      logger.error('Error in fetchNavData: ', action.error);
      return {
        ...state,
      };
    });
  },
});

export const getLMSHeaders = (state) => {
  if (state.envData.ENVIRONMENT !== PROD_ENV) {
    return state.envData.LMS_HEADERS;
  }

  return {};
};

export const getNavItems = (state) => state.envData[NAV_ITEMS];

export default envSlice.reducer;
